import { render, staticRenderFns } from "./FontesMonitoradas.vue?vue&type=template&id=cdec0004&scoped=true&"
import script from "./FontesMonitoradas.vue?vue&type=script&lang=js&"
export * from "./FontesMonitoradas.vue?vue&type=script&lang=js&"
import style0 from "./FontesMonitoradas.vue?vue&type=style&index=0&id=cdec0004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdec0004",
  null
  
)

export default component.exports